import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import { CompetitionEditionDetail } from "features/competition/CompetitionEditionDetail";
import { useEffect } from "react";
import "style/discoverPage.css";

export function CompetitionEditionDetailPage() {
	useEffect(() => {
		setScrollBehavior();
	}, []);

	return (
		<div className="discover-container discover-container--wide">
			<CompetitionEditionDetail />
		</div>
	);
}

export default CompetitionEditionDetailPage;
